import React from 'react';
import classNames from 'classnames';
import './SegmentedControl.scss';

export interface SegmentedControlOption<TValue extends string> {
  value: TValue;
  label: string;
}

export interface SegmentedControlProps<TValue extends string> {
  options: SegmentedControlOption<TValue>[];
  value: TValue;
  onChange: (value: TValue) => void;
  className?: string;
}

export const SegmentedControl = <TValue extends string>({
  options,
  value,
  onChange,
  className,
}: SegmentedControlProps<TValue>): JSX.Element => {
  return (
    <div className={classNames('syte-segmented-control', className)}>
      {options.map(option => (
        <button
          key={option.value}
          type='button'
          className={classNames('syte-segmented-control-option', {
            'syte-segmented-control-option-selected': option.value === value,
          })}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};
